import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { getCookie } from "@jti/fe-common";
import { ShopPageTeaser } from "./ShopPageTeaser";
import "./ShopLandingPage.scss";
const rootClassName = "aem-shopLandingPage";
const shopElementsSelector = ".aem-productTeaserContainer__base, .aem-shopFilter__base";
/**
 * Hide shop elements on the shop page if the language wasn't selected yet.
 */
export const hideShopElements = () => {
    const shopElements = document.querySelectorAll(shopElementsSelector);
    shopElements.forEach((element) => {
        element.classList.add(`${rootClassName}-sibling--hidden`);
    });
};
export const ShopLandingPage = ({ title, subtitle, shopPageTeasers }) => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const currentLanguage = getCookie("language");
        if (!currentLanguage) {
            hideShopElements();
            setIsVisible(true);
        }
    }, []);
    return (_jsxs("div", { className: classNames(rootClassName, {
            [`${rootClassName}--visible`]: isVisible,
        }), "data-testid": "shop-landing-page", "aria-hidden": !isVisible, children: [_jsxs("header", { className: `${rootClassName}__header`, children: [_jsx("h1", { className: `${rootClassName}__title`, children: title }), subtitle && _jsx("h2", { className: `${rootClassName}__subtitle`, children: subtitle })] }), _jsx("nav", { children: _jsx("ul", { className: `${rootClassName}__teasers-container`, children: shopPageTeasers?.map(({ title, path, backgroundImage, relatedLanguage }) => {
                        return (_jsx(ShopPageTeaser, { title: title, path: path, backgroundImage: backgroundImage, relatedLanguage: relatedLanguage }, title));
                    }) }) })] }));
};
//# sourceMappingURL=ShopLandingPage.js.map